<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-meeting-room`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 46a2 2 0 01-2-2V8.548a2 2 0 011.63-1.966l22-4.136A2 2 0 0132 4.41V10h8a2 2 0 012 2v32a2 2 0 01-2 2H8zM28 7l-18 3.392V42h18V7zm10 7h-6v28h6V14zm-15 8a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconMeetingRoom',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
